<template>
  <Breadcrumbs :breadcrumbs="[{ text: $t('pages.offers'), to: 'offers' }]" />
  <div class="offers-page container mb-4">
    <OfferCategoriesList class="categories-list" />
    <div class="offers">
      <BaseTitle :style="{ marginTop: '0px' }">{{ pageTitle }}</BaseTitle>
      <DynamicContent
        id="offer-content"
        class="container dynamic-content"
        :html="pageContentBlock"
        :style="{ padding: 0 }"
      ></DynamicContent>
      <OfferSearchInput :search-query="searchQuery" class="mb-1" />
      <OffersGrid
        :pagination="{ limit: 24, offset: 0 }"
        :input="{
          search: debouncedSearchQuery,
          ...(offerCategory && { offerCategorySlug: offerCategory }),
        }"
        :infinite-loading="true"
        class="offers-grid small-tiles"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouteQuery } from "@vueuse/router";
import { useWebsitePageQuery } from "~/graphql/generated";

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    "nl-NL": "/aanbiedingen/[slug]",
    fr: "/offres/[slug]",
    nl: "/aanbiedingen/[slug]",
  },
});

const searchQuery = useRouteQuery("search-offers", "", { transform: String });
const offerCategory = useRouteParams("slug", "", {
  transform: String,
});

const debouncedSearchQuery = useDebounce(searchQuery, 500);

// Set the page title
const { t } = useI18n();
const pageTitle = t("offer.page-title", [offerCategory.value]);

useHead({
  title: t("offer.title", [offerCategory.value]),
});

// Set the (optional) page content blocks
const path = useRoute().path;

const { websitePagePath } = useWebsitePagePath(path);

const page = await useWebsitePageQuery({
  variables: websitePagePath,
});

// Currently the type of `page` gives us errors that contentBlocks doesn't exist (it does), so we sprinkle @ts-expect-error here and there.
const pageContentBlock = computed(() => {
  return page.data.value?.websitePage &&
    // @ts-expect-error
    page.data.value?.websitePage?.contentBlocks &&
    // @ts-expect-error
    page.data.value?.websitePage.contentBlocks[0]
    ? // @ts-expect-error
      page.data.value?.websitePage.contentBlocks[0]
    : null;
});
</script>

<style lang="scss" scoped>
.offers-page {
  display: flex;
  gap: 1.5rem;

  @include for-small-screen {
    flex-direction: column;
  }

  .categories-list {
    min-width: 14rem;
    width: 20%;

    @include for-small-screen {
      width: 100%;
    }
  }

  .offers {
    flex: 1;
  }

  .offers-grid {
    padding: 0;
  }
}
</style>
